import { render, staticRenderFns } from "./addOrEditComplexCompetition.vue?vue&type=template&id=5cb219be&scoped=true"
import script from "./addOrEditComplexCompetition.vue?vue&type=script&lang=ts"
export * from "./addOrEditComplexCompetition.vue?vue&type=script&lang=ts"
import style0 from "./addOrEditComplexCompetition.vue?vue&type=style&index=0&id=5cb219be&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cb219be",
  null
  
)

export default component.exports